import { Popconfirm } from 'element-ui'

const YPopconfirm = Popconfirm
YPopconfirm.$depends = [Popconfirm]
YPopconfirm.$name = 'y-popconfirm'
YPopconfirm._name = 'Popconfirm 气泡确认框'

export default YPopconfirm
